module.exports = __webpack_public_path__ + "img/T004_Shopping.c4c18d65.png";